// extracted by mini-css-extract-plugin
export default {"centeredDot":"styles_centeredDot__fpooh"};